import { useState } from 'react';
import { headTableCell } from 'containers/pages/contacts/data/contacts';

function useContactList() {
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('');
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(true);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [selectedIds, setSelectedIds] = useState([]);

	const onRequestSort = (e, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const onSort = (property) => (e) => {
		onRequestSort(e, property);
	};

	const onDense = () => {
		setDense(!dense);
	};

	const onPage = (e, newPage) => {
		setPage(parseInt(newPage));
	};

	const onRowsPerPage = (e) => {
		setRowsPerPage(parseInt(e.target.value, 10));
		setPage(0);
	};

	const onForm = (id) => {
		if (selectedIds.includes(id)) {
			const filteredSelectedIds = selectedIds.filter((selectedId) => selectedId !== id);
			setSelectedIds(filteredSelectedIds);
		} else {
			setSelectedIds([...selectedIds, id]);
		}
	};

	const state = { headTableCell, order, orderBy, page, dense, rowsPerPage, selectedIds };

	const handler = { onRequestSort, onSort, onForm, onRowsPerPage, onPage, onDense };

	return { state, handler };
}

export default useContactList;
